module.exports = __webpack_public_path__ + "static/media/aw.4afd5bb9.svg";